import { CalendarDays, ClipboardCheck, Globe2, House, KeyRound, LogOut, Menu, MessageCircleMore, Settings2, Users, X } from "lucide-react";
import { useState } from "react";
import { NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { QoricanchaMark } from "./PublicHeader";
import { ADMIN_HOST, PUBLIC_ORIGIN } from "../../shared/hosts";

const navigation = [
  { to: "/staff", label: "Today", icon: House, end: true },
  { to: "/staff/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/staff/guests", label: "Guests", icon: Users },
  { to: "/staff/messages", label: "Messages", icon: MessageCircleMore },
  { to: "/staff/tasks", label: "Tasks", icon: ClipboardCheck },
  { to: "/staff/website", label: "Website", icon: Globe2 },
  { to: "/staff/more", label: "More", icon: Settings2 },
  { to: "/staff/account", label: "Account", icon: KeyRound },
];

const titles: Record<string, string> = {
  "/staff": "Today", "/staff/calendar": "Reservations", "/staff/guests": "Guests",
  "/staff/messages": "Guest messages", "/staff/tasks": "Housekeeping & tasks", "/staff/website": "Website & content", "/staff/more": "Settings & connections", "/staff/account": "Account security",
};

export function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  if (loading) return <div className="app-loading"><span className="loading-spinner" /></div>;
  if (!user) return <Navigate to={`/staff/login${location.search.includes("lang=es") ? "?lang=es" : ""}`} replace state={{ from: location.pathname + location.search }} />;
  return (
    <div className="admin-shell">
      <aside className={menuOpen ? "admin-sidebar open" : "admin-sidebar"}>
        <div className="sidebar-brand"><span className="brand-mark"><QoricanchaMark /></span><div><span>Sight Qoricancha</span><small>Reception</small></div><button className="icon-button sidebar-close" aria-label="Close menu" onClick={() => setMenuOpen(false)}><X /></button></div>
        <nav className="admin-nav">{navigation.map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end} onClick={() => setMenuOpen(false)}><Icon size={20} /><span>{label}</span></NavLink>)}</nav>
        <div className="sidebar-status"><span className="status-dot warning" /><div><strong>Channels not connected</strong><small>Manual reconciliation required</small></div></div>
        <button className="user-card" onClick={() => void logout()}><span className="user-avatar">{user.displayName.slice(0, 2).toUpperCase()}</span><span><strong>{user.displayName}</strong><small>{user.role}</small></span><LogOut size={18} /></button>
      </aside>
      {menuOpen && <button className="sidebar-scrim" onClick={() => setMenuOpen(false)} aria-label="Close menu" />}
      <div className="admin-content">
        <header className="admin-topbar"><button className="mobile-menu admin-menu" aria-label="Open menu" onClick={() => setMenuOpen(true)}><Menu /></button><div><span className="eyebrow">{user.propertyName}</span><h1>{titles[location.pathname] ?? "Guest operations"}</h1></div><a className="property-switcher" href={window.location.hostname === ADMIN_HOST ? PUBLIC_ORIGIN : "/"} target="_blank" rel="noreferrer" aria-label="View guest website"><Globe2 size={18} /><span>View website</span></a></header>
        <main className="admin-main"><Outlet /></main>
      </div>
      <nav className="mobile-bottom-nav">{navigation.slice(0, 5).map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end}><Icon /><span>{label}</span></NavLink>)}</nav>
    </div>
  );
}
